import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Lindelani Mbatha',
    title: "Platforms Engineer",
    desciption:"What is my purpose? I pass butter. Moreover, I am a Software Engineer specialising in Platforms development, which is just Dev-Ops with extra steps.",
    image: 'https://media.licdn.com/dms/image/C4D03AQFpjTlXoeAOlg/profile-displayphoto-shrink_800_800/0/1659377402084?e=1726704000&v=beta&t=a-dj5WNReyTymw2gGQpVJHj5JOeEAfXhpku1diaKNu8',
    resumePdf: resume
}
